import React from 'react';

const PaginationControls = ({ currentPage, totalPages, onPageChange, lang }) => {
  const isRtl = lang === 'he';
  const go = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange?.(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="pagination" aria-label="Pagination">
      <button
        type="button"
        className="pagination-button"
        aria-label="Previous page"
        disabled={currentPage === 1}
        onClick={() => go(currentPage - 1)}
      >
        <span className="material-symbols-rounded" aria-hidden="true">
          {isRtl ? 'arrow_forward' : 'arrow_back'}
        </span>
      </button>
      <div className="pagination-pages">
        {Array.from({ length: totalPages }, (_, index) => {
          const page = index + 1;
          const isActive = page === currentPage;

          return (
            <button
              type="button"
              key={page}
              className={`pagination-page${isActive ? ' is-active' : ''}`}
              aria-current={isActive ? 'page' : undefined}
              onClick={() => go(page)}
            >
              {page}
            </button>
          );
        })}
      </div>
      <button
        type="button"
        className="pagination-button"
        aria-label="Next page"
        disabled={currentPage === totalPages}
        onClick={() => go(currentPage + 1)}
      >
        <span className="material-symbols-rounded" aria-hidden="true">
          {isRtl ? 'arrow_back' : 'arrow_forward'}
        </span>
      </button>
    </nav>
  );
};

export default PaginationControls;
